import { useMMKVString } from 'react-native-mmkv';

import { storage, storageKeys } from '@/constants/storage';

import { useHasSession } from './useHasSession';

/**
 * The signed-in customer's id, or undefined for a guest. Read from storage, not
 * the customer query, so a cart names its customer before the profile loads
 * and squire-api never fuzzy-matches a signed-in booking (SQR-15987).
 */
export const useSessionCustomerId = (): string | undefined => {
  const [customerId] = useMMKVString(storageKeys.customerId, storage);
  const hasSession = useHasSession();
  return (hasSession && customerId) || undefined;
};
